// ============================
// FILE: MasterCPResource.js
// ============================

import { useState, useEffect } from "react";
import "../assets/MasterCPResource.css";

// ===== PROJECT IMAGES =====

// River Paradise
import rpHero from "../assets/imgs/RiverParadise/river-paradise.png";

// Waterscape
import waterscapeHero from "../assets/imgs/Waterscape/water-touch-bunglow.webp";

// Lonavalley
import lonavalleyHero from "../assets/imgs/Lonavalley/lonavala-uskan-dam.webp";

// Riviera Greens
import rivieraHero from "../assets/rivieraGreens/Renterence.webp";

// Rajgad Farms
import rajgadHero from "../assets/imgs/RajgadFarms/Khariv_rf.png";

// Kanandi Farms
import kanandiHero from "../assets/imgs/KanandiFarms/Kanandi_farms.jpeg";

// Swaraj Toran
import swarajHero from "../assets/imgs/SwarajToran_farms/swaraj_toran_farms.png";

// Tamhini
import majesticHero from "../assets/imgs/Tamhini/tamhini_.png";

// Aatmabodh
import atmabodhHero from "../assets/imgs/Vatika/aatmabodh_vatika.png";

// Savali
import savaliHero from "../assets/imgs/SawaliR/sawali_plots.png";

// Foresta
import forestaHero from "../assets/imgs/Foresta/foresta.png";

export default function MasterCPResource() {

    const [selectedProject, setSelectedProject] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isUnlocked, setIsUnlocked] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
    });

    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        if (isUnlocked) {
            setTimeout(() => {
                setShowPopup(true);
            }, 10000);
        }
    }, [isUnlocked]);

    // ============================
    // PROJECT DATA
    // ============================

    const projects = [

        {
            name: "Lonavalley",
            tagline: "Resort NA Plots @Lonavala Annexe",
            image: lonavalleyHero,

            brochure: "https://drive.google.com/drive/folders/1u6idXjd-4tZrCf3qBJwzEb7U412copMj?usp=sharing",
            layout: "https://drive.google.com/drive/folders/1PiScEJ2kfu2JoRvV0PWt4gtRsfqrwi9j?usp=sharing",
            videos: "https://drive.google.com/drive/folders/17x5eHoyeMDabNFzEAZSxknnXmQkKvDCx?usp=sharing",
            pricing: "https://drive.google.com/drive/folders/1rz26d5WhK2HN-Q9nuM8B7Cj2EzG8hx0d?usp=sharing",
            creatives: "https://drive.google.com/drive/folders/12hkh1x1e_PqIDKibd-5DfMLCXEgSlrXi?usp=sharing",
            writeup: "https://drive.google.com/drive/folders/1lLaYxc-G__ow8YGgN00UKjWLcitPpi8l?usp=sharing",
        },

        {
            name: "Sinhagad County @Donje",
            tagline: "Wellness inspired Bungalow community ",
            image: atmabodhHero,

            brochure: "https://drive.google.com/drive/folders/1wPxjQJsvk-KY5bk9jnyLWrW4IyqsaKsM?usp=sharing",
            layout: "https://drive.google.com/drive/folders/1GsPL5fUantdYm_PL_dalmBevmDKImuLa?usp=sharing",
            videos: "https://drive.google.com/drive/folders/1bO-pPrgAIgNyjTO2aHFPKVIiZ2AiuFb1?usp=sharing",
            pricing: "https://drive.google.com/drive/folders/1PM2pNEyVteYzfJ4uo0wCITQbN4bQHLC4?usp=sharing",
            creatives: "https://drive.google.com/drive/folders/1s6ghEcdXwq4T7vdpWkqGv0R4T9Zf5oOi?usp=sharing",
            writeup: "https://drive.google.com/drive/folders/1-SbZZX1diOyPvTLgHIrVqIjb13zG0axn?usp=sharing",
        },

        {
            name: "Waterscape",
            tagline: "Backwater Living Experience : Water Touch & View Farmhouse plots",
            image: waterscapeHero,

            brochure: "https://drive.google.com/drive/folders/1cIjo1zY26EvKE9m49HcCUaGhyjk4nUje?usp=sharing",
            layout: "https://drive.google.com/drive/folders/1_0FRVjvdH_jEuusZWodc-NSlBQww50or?usp=sharing",
            videos: "https://drive.google.com/drive/folders/1ngkei3NF8QH0SPlIUhDj6cvSldgP9j0Z?usp=sharing",
            pricing: "https://drive.google.com/drive/folders/17Tx_L0fB6KB7SlQFbhoZbXbECbeHo_3w?usp=sharing",
            creatives: "https://drive.google.com/drive/folders/1COpgDOoy4iqIzGocSNgJ-b4djU1Ma2u4?usp=sharing",
            writeup: "https://drive.google.com/drive/folders/1JsGIVUK4cM4Q5IyHyVLG2wkxvJejiJiK?usp=sharing",
        },

        {
            name: "Riviera Greens",
            tagline: "Gunjawani Dam View Plots",
            image: rivieraHero,

            brochure: "https://drive.google.com/drive/folders/14wg-I9Pa1uMtVVbjY7-kd88fT-fo3-sU?usp=sharing",
            layout: "https://drive.google.com/drive/folders/19BWxDKs4Y-LwbyAY1W_xx4qiIKvYP_lv?usp=sharing",
            videos: "https://drive.google.com/drive/folders/1O7UbgXkvd_9my4wbchLk9EeAFi0ujrLH?usp=sharing",
            pricing: "https://drive.google.com/drive/folders/1GsHQfKm7C73oonRpVU9fIaOR0ZlArJCO?usp=sharing",
            creatives: "https://drive.google.com/drive/folders/1G5UHvKvxFW0PoD9-Cxspl186iUfA5Z0G?usp=sharing",
            writeup: "https://drive.google.com/drive/folders/1Wg26MZjwu4aUBSjMGVElrE8fhXCdmCNC?usp=sharing",
        },

        {
            name: "The Majestic Falls @ Tamhini",
            tagline: "Waterfall Side Nature Living",
            image: majesticHero,

            brochure: "https://drive.google.com/drive/folders/1pXFzUjWXEdTtHYObYlsq46ajk-H75How?usp=sharing",
            layout: "https://drive.google.com/drive/folders/1BMKdwafd-x-5nsFnsSiRtDby6vw935kw?usp=sharing",
            videos: "https://drive.google.com/drive/folders/1PN6GlONSsC8vk9Z0P6jASXOiG993l-Fn?usp=sharing",
            pricing: "https://drive.google.com/drive/folders/1-13vA6lxvZ54lR6Bq6QPiHhgzHqsI2eC?usp=sharing",
            creatives: "https://drive.google.com/drive/folders/1CWB1AMHKyPUgHCpRAFVXHQGp0zFXB_QG?usp=sharing",
            writeup: "https://drive.google.com/drive/folders/1rf8NlD1DKXwQvIPmDbsn4h4FmB0WpWaw?usp=sharing",
        },

        {
            name: "River Paradise",
            tagline: "Where Nature Meets Luxury Investment : River Touch Farmhouse plots",
            image: rpHero,
            status: "sold-out",

            brochure: "https://drive.google.com/drive/u/6/folders/1ub1O0ROERsfcoTovz1YQ-PbnSrkBzRXP",
            layout: "https://drive.google.com/drive/u/6/folders/1_8vlz3Udin_n-3QxSj8J7SUbkVhYUX8M",
            videos: "https://drive.google.com/drive/u/6/folders/1TseU1IPYUVfA0ndQpZsqH629YZYmKMY3",
            pricing: "https://drive.google.com/drive/u/6/folders/1PXcEQVrvaUB3xFAEVEQR89lwmqcKTAHr",
            creatives: "https://drive.google.com/drive/u/6/folders/1EchSJkWWF2S-MiD5XAW1G-fSAreo7raZ",
            writeup: "",
        },

        {
            name: "Rajgad Farms",
            tagline: "Dam View Farmhouse plots @Velhe Khariv",
            image: rajgadHero,
            status: "sold-out",

            brochure: "https://drive.google.com/drive/folders/1ULQA5ucjMuT3SGYJED5njHF4PrkuUkm7?usp=sharing",
            layout: "https://drive.google.com/drive/folders/1mPt_DNknpeOpkAnyVAFIBd7cU63TJ2YS?usp=sharing",
            videos: "https://drive.google.com/drive/folders/1M1GKk_PebRH0DhXoZmkz2JlJufxX3s3u?usp=sharing",
            pricing: "https://drive.google.com/drive/folders/1XefJ2VQNpQ9xKgomeoWrR8nkfdwD1B94?usp=sharing",
            creatives: "https://drive.google.com/drive/folders/1isWLSzWiyQ1E4hPFrA_BjexFSO-amAYN?usp=sharing",
            writeup: "https://drive.google.com/drive/folders/1hIhVisQcOk4eoRjVv_yT-rNwfouNQv2j?usp=sharing",
        },

        {
            name: "Kanandi Farms(@velhe Kanand)",
            tagline: "Escape Into Serenity",
            image: kanandiHero,
            status: "sold-out",

            brochure: "https://drive.google.com/drive/folders/1N45n-UGS3eTM3_awVg9duKjOLuCn3OR2?usp=sharing",
            layout: "https://drive.google.com/drive/folders/1Zv6PZQoy3uJVrz5TsSgQTi61YbTA2Upu?usp=sharing",
            videos: "https://drive.google.com/drive/folders/1b-YKLDXc7a73i1PSRIvMZdyOMSdx4Xc9?usp=sharing",
            pricing: "https://drive.google.com/drive/folders/1cqOlZBze9FdPUIIqF5iv3ip1gr9WLFLX?usp=sharing",
            creatives: "https://drive.google.com/drive/folders/1EVJrGEnTVLcjmzsPamh1WncIscSvGRE0?usp=sharing",
            writeup: "https://drive.google.com/drive/folders/1WfH4VkRi12nZsu_MA3RsMprY1C7y63B5?usp=sharing",
        },

        // {
        //     name: "Swaraj Toran Farms(@velhe Ghevande) ",
        //     tagline: "A Place That Lives For Generations",
        //     image: swarajHero,

        //     brochure: "https://drive.google.com/drive/folders/1bUCNzaDYXmvb8OMIn15VOKTa7FkqkmnD?usp=sharing",
        //     layout: "https://drive.google.com/drive/folders/1Aof8itgzksi6on2neglDos3GZveR91x7?usp=sharing",
        //     videos: "https://drive.google.com/drive/folders/1bhcsWh0lqMH3MLBVy9iWZT2Zg7b7ABmI?usp=sharing",
        //     pricing: "https://drive.google.com/drive/folders/1SAmEgfffCX3KnjIJIriJs4MaYhEH_aHc?usp=sharing",
        //     creatives: "https://drive.google.com/drive/folders/1N3MLkjxGB6kHGizwl8w5bVQ8VXJVIA09?usp=sharing",
        //     writeup: "https://drive.google.com/drive/folders/16qanG7kzRvdoKGia-gV5ZgL5I4EOwH2j?usp=sharing",
        // },


        // {
        //     name: "Savali Residency@ R Zone plots",
        //     tagline: "Premium Living @ Kondhanpur",
        //     image: savaliHero,

        //     brochure: "https://drive.google.com/drive/folders/1VkbmteK27PhGs8Jgs_uRhXDf5sBBZZYi?usp=sharing",
        //     layout: "https://drive.google.com/drive/folders/19Ej7OqYzMm9GhtOWoWChh19AfkXOpnco?usp=sharing",
        //     videos: "https://drive.google.com/drive/folders/1nhcmjwEwCu4TyMUq0qwsUt3sywAKIq-G?usp=sharing",
        //     pricing: "https://drive.google.com/drive/folders/1417NZGdAHP9OJ9LWFiZ06zDBiFf-TfZA?usp=sharing",
        //     creatives: "https://drive.google.com/drive/folders/17DNAWDrnRdWeKV40VfsjojUUH3IeqW-D?usp=sharing",
        //     writeup: "https://drive.google.com/drive/folders/1eVuhS1hcqTXBhlfMSuF0o_odEw7J3Evg?usp=sharing",
        // },

        // {
        //     name: "Foresta",
        //     tagline: "2,3,4 BHK Bungalow Plots",
        //     image: forestaHero,

        //     brochure: "https://drive.google.com/drive/folders/1V2OZFYDFwHaH8gDatMUMIGUbp2VwbYN2?usp=sharing",
        //     layout: "https://drive.google.com/drive/folders/1_SahG5nfDjxuw8KS_JAPjnUKPIC9PFuL?usp=sharing",
        //     videos: "https://drive.google.com/drive/folders/18QJHDbwig7c8w6mNPxltbKC7EX1bmJ84?usp=sharing",
        //     pricing: "https://drive.google.com/drive/folders/14v_DdgXL_tj0DKAt3cJVxcqzLxCF4PZg?usp=sharing",
        //     creatives: "https://drive.google.com/drive/folders/1efzUnW1Kf1FozGOAiWpeAzqlCxjZawDr?usp=sharing",
        //     writeup: "https://drive.google.com/drive/folders/1L0hPAdCCSDmrEvQ4jHvtcytBxde_TOOz?usp=sharing",
        // }

    ];

    // ============================
    // HANDLE FORM
    // ============================

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // ============================
    // SUBMIT
    // ============================

    const handleSubmit = async () => {

        if (!formData.name || !formData.mobile) {
            return alert("Please fill all fields");
        }

        if (!/^[0-9]{10}$/.test(formData.mobile)) {
            return alert("Enter valid 10 digit mobile number");
        }

        setLoading(true);

        try {

            const res = await fetch(
                "https://samriddhidevelopers.in/backend/master_save_cp.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify({
                        ...formData,
                        project: selectedProject.name,
                    }),
                }
            );

            const data = await res.json();

            if (data.status === "success") {
                setIsUnlocked(true);
            }

        } catch (err) {
            console.error(err);
            alert("Server Error");
        }

        setLoading(false);
    };

    return (

        <div className="master-container">

            {/* ============================
                HERO
            ============================ */}

            {!selectedProject && (

                <div className="master-hero">

                    <div className="master-overlay">

                        <h1>
                            Resource Center
                        </h1>

                        <p>
                            Access brochures, layouts, videos, pricing &
                            everything you need to close deals
                        </p>

                    </div>

                </div>
            )}

            {/* ============================
                PROJECT GRID
            ============================ */}


            {!selectedProject && (

                <div className="project-grid">

                    {projects.map((project, index) => (

                        <div
                            key={index}
                            className="project-card"
                        >

                            <img
                                src={project.image}
                                alt={project.name}
                            />

                            <div className="project-card-overlay">
                                {project.status === "sold-out" && (
                                    <span className="sold-out-badge">
                                        SOLD OUT
                                    </span>
                                )}

                                <h2>{project.name}</h2>

                                <p>{project.tagline}</p>

                                {project.status === "sold-out" ? (
                                    <button className="access-btn sold-out-btn" disabled>
                                        Materials Unavailable
                                    </button>
                                ) : (
                                    <button
                                        className="access-btn"
                                        onClick={() => {
                                            setSelectedProject(project);
                                            setShowForm(true);
                                        }}
                                    >
                                        Access CP Material
                                    </button>
                                )}

                            </div>

                        </div>

                    ))}

                </div>
            )}

            {/* ============================
                FORM MODAL
            ============================ */}


            {showForm && !isUnlocked && (

                <div className="modal">

                    <div className="modal-content">

                        <button
                            className="mclose-modal"
                            onClick={() => {
                                setShowForm(false);
                                setSelectedProject(null);
                            }}
                        >
                            ✕
                        </button>

                        <h2>
                            Unlock {selectedProject.name}
                        </h2>

                        <p>
                            Access complete CP marketing material
                        </p>

                        <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            onChange={handleChange}
                        />

                        <input
                            type="text"
                            name="mobile"
                            placeholder="Mobile Number"
                            onChange={handleChange}
                        />

                        <button className="m-close-button"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? "Please wait..." : "Unlock Access"}
                        </button>

                    </div>

                </div>
            )}
            {/* ============================
                DASHBOARD
            ============================ */}

            {isUnlocked && (

                <div className="dashboard">

                    <div className="dashboard-inner">

                        <h1 className="dashboard-title">
                            {selectedProject.name} Marketing Material
                        </h1>

                        <p className="dashboard-sub">
                            Everything you need to close deals is below
                        </p>

                        <div className="grid">

                            <a
                                href={selectedProject.brochure}
                                target="_blank"
                                className="card"
                            >
                                📘 Brochure
                            </a>

                            <a
                                href={selectedProject.layout}
                                target="_blank"
                                className="card"
                            >
                                🗺 Layout
                            </a>

                            <a
                                href={selectedProject.videos}
                                target="_blank"
                                className="card"
                            >
                                🎥 Videos
                            </a>

                            <a
                                href={selectedProject.pricing}
                                target="_blank"
                                className="card"
                            >
                                📄 Price Sheet
                            </a>

                            <a
                                href={selectedProject.creatives}
                                target="_blank"
                                className="card"
                            >
                                📢 Creatives
                            </a>
                            <a
                                href={selectedProject.writeup}
                                target="_blank"
                                className="card"
                            >
                                📢 writeup
                            </a>

                        </div>

                    </div>

                </div>
            )}

            {/* ============================
                POPUP
            ============================ */}

            {showPopup && (

                <div className="popup">

                    <p>
                        Need help closing a deal?
                    </p>

                    <a href="tel:9730050099">
                        Contact Sales Team
                    </a>

                </div>
            )}

        </div>
    );
}